"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoliteInvitationInitRequest = void 0;
var PoliteInvitationInitRequest = /** @class */ (function () {
    function PoliteInvitationInitRequest() {
    }
    return PoliteInvitationInitRequest;
}());
exports.PoliteInvitationInitRequest = PoliteInvitationInitRequest;
;
//# sourceMappingURL=politeInvitationInit.request.js.map